<kal-form-field [class.without-label]="!label" [kalLoading]="loading" class="gup-C-formFieldSize--bottomNull">

    <app-shared-searchbar-list [formControl]="formControl"
                               [label]="label"
                               [placeholder]="placeholder"
                               [required]="required"
                               disableFirstOptionSelection>
        <ng-template #searchbarTemplate
                     let-searchbarValue="searchbarValue">
             <span [style.text-indent.em]="searchbarValue.Niveau - 1">
                {{ searchbarValue.Libelle }}
            </span>
        </ng-template>

        <kal-option *ngFor="let section of planAndSections?.sections"
                    [appSharedSearchbarParameters]="section"
                    [searchbarTemplate]="searchbarTemplate"
                    [value]="section.Id">
            {{ section.Libelle }}
        </kal-option>
    </app-shared-searchbar-list>

</kal-form-field>

